// Converts a date string (e.g., "2025-04-25") into a local JavaScript Date object
// with time set to 11:59:59 PM to ensure events ending that day are still included
export function localDate(date) {
  if (date === null || typeof date !== "string") {
    return null;
  }

  const parsedDate = date.split("-");

  // Validate that all parts of the date are numeric
  if (parsedDate.filter((e) => isNaN(Number(e))).length > 0) {
    return false;
  }

  // Construct a local Date object, adjusting month (0-based index)
  const localDate = new Date(
    Number(parsedDate[0]), // year
    Number(parsedDate[1]) - 1, // month (0-based)
    Number(parsedDate[2]), // day
    23,
    59,
    59 // set time to 11:59:59 PM
  );

  return localDate;
}

// Takes a date string and returns a new Date object that is 30 days later
// Uses localDate to preserve timezone and consistent parsing
export function localDatePlus30(date) {
  const baseDate = localDate(date);

  // If baseDate is null or false (invalid), return the same
  if (!baseDate) return baseDate;

  // Add 30 days in milliseconds
  const thirtyDaysLater = new Date(
    baseDate.getTime() + 30 * 24 * 60 * 60 * 1000
  );
  return thirtyDaysLater;
}
